<div *ngIf="view === 'list'" [@toRight]="view" [@.disabled]="animationDisabled" class="wrap uk-margin-bottom">

    <div class="uk-margin-bottom">
        <div class="title-offset">
            <span class="main-title"><span class="bold">Messagerie</span> 2 tickets ouverts</span>
        </div>
    </div>

    <div class="uk-width-1-1" style="margin-left: -20px;" uk-grid>
        <div class="uk-margin uk-display-inline-block research-form-controls">
            <div class="uk-form-controls uk-display-inline-block" style="margin-top: 20px; width: 200px;">
                <select class="combo-list" id="form-horizontal-select" [(ngModel)]="status">
                    <option value="0">Tous les statuts</option>
                    <option value="1">Ouvert</option>
                    <option value="2">Clôturé</option>
                </select>
            </div>
        </div>
        <div class="uk-margin uk-display-inline-block research-form-controls" style="width: 420px;">
            <div class="uk-form-controls uk-display-inline-block uk-position-relative uk-width-1-1">
                <span *ngIf="loading === false" class="uk-form-icon uk-form-icon-flip">
                    <img src="../../../assets/icons/Search.svg" width="24px" height="24px" alt="user"/>
                </span>
                <span *ngIf="loading === true" class="uk-form-icon uk-form-icon-flip">
                    <div style="width:24px; height: 24px;" uk-spinner></div>
                </span>
                <input class="search-bar" type="text" [(ngModel)]="userSearch"
                    (ngModelChange)="updateUserOptionList($event)"
                    (focus)="toggleSuggestions(true)" (focusout)="toggleSuggestions(false)"
                    placeholder="Rechercher un utilisateur"
                >
                <div [class.display-none]="userDisplay === false || loading === true" class="suggestions">
                    <div [class.display-none]="userOptions.length === 0" class="arrow"></div>
                    <div [class.display-none]="noResult === true" *ngFor="let option of userOptions"
                        (click)="setUserSearch(option)"
                    >
                        {{ option.FirstName }} {{ option.LastName }}
                    </div>
                    <div [class.display-none]="noResult === false">
                        Pas de résultats
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top">
        <div uk-grid *ngFor="let ticket of tickets; let i = index"
        class="uk-width-1-1 item-list remove-grid-ml-pl pointer"
        (click)="toggleMessageView(ticket)">
            <div class="uk-width-1-12 item-column">
                <img class="uk-position-absolute" style="left: 10px;" src="../../../assets/icons/User.svg" width="64px" height="64px" alt="user"/>
            </div>
            <div class="uk-width-3-12 item-column">
                <span>{{ ticket.user }}</span>
            </div>
            <div class="uk-width-expand item-column">
                <span humanDateFormat="{{ ticket.ISODateCreation }}"></span>
            </div>
            <div class="uk-width-2-12 item-column">
                <span *ngIf="ticket.status === 1" class="item-status color-green">
                    <span class="material-icons" style="vertical-align: middle;">fiber_manual_record</span>
                    Ouvert #{{ticket.id}}
                </span>
                <span *ngIf="ticket.status === 2" class="item-status color-turquoise">
                    <span class="material-icons" style="vertical-align: middle;">fiber_manual_record</span>
                    Clôturé #{{ticket.id}}
                </span>
            </div>
            <div class="uk-width-1-12 item-column">
                <img class="uk-position-absolute" style="right: 10px;" src="../../../assets/icons/TRIANGLE Right.svg" width="48px" height="48px" alt="user"/>
            </div>
        </div>
    </div>

</div>

<div *ngIf="view === 'details'" [@toLeft]="view" class="wrap uk-margin-bottom">
    <div class="uk-margin-bottom">
        <div (click)="toggleListView()" class="back-button">
            <img src="../../../assets/icons/Back.svg" width="32px" height="32px" alt="back">
            <span>Liste des messages</span>
        </div>
    </div>
    <div class="uk-margin-bottom">
        <span class="main-title color-cold-grey"><span class="bold">Messages</span> avec {{ ticket.user }}</span>
        <div class="back-button uk-float-right" style="margin-top: 8px;">
            <span>Clôturer</span>
            <img src="../../../assets/icons/Close.svg" width="32px" height="32px" alt="close">
        </div>
    </div>
    <div uk-grid class="remove-grid-ml-pl uk-margin-remove-top vop-background-white" style="padding-bottom: 30px;">
        <div class="uk-width-expand main-title uk-margin-left uk-margin-top">
            <span class="bold">Réservation</span>
            <img class="color-cold-grey" src="../../../assets/icons/ArrowRight.svg" width="40px" height="40px" alt="right"/><br>
            <span class="date">De 07/07/2020 à 14h00 à 07/07/2020 à 16h00</span>
        </div>
        <div class="uk-width-auto uk-margin-right uk-margin-top author">
            <img src="../../../assets/icons/User.svg" width="32px" height="32px" alt="user"/>
            <span class="bold">{{ ticket.user }}</span><br>
            <img src="../../../assets/icons/Vehicle.svg" width="32px" height="32px" alt="vehicle"/>
            {{ ticket.vehicle }}
        </div>
        <div uk-grid *ngFor="let message of ticket.messages; let i = index"
        class="uk-width-1-1 remove-grid-ml-pl uk-margin-top">
            <div class="uk-width-1-1 author" [class.text-right]="message.admin === true">
                <img src="../../../assets/icons/User.svg" width="32px" height="32px" alt="user"/>
                <b>{{ message.author }}</b>
                <span style="margin-left: 5px;" humanDateFormat="{{ message.ISODateCreation }}" noDay="true"></span>
            </div>
            <div class="uk-width-1-1 card uk-margin-remove-top uk-margin-left uk-margin-right">
                <span class="uk-margin-left">{{ message.content }}</span>
            </div>
        </div>
        <div uk-grid class="uk-width-1-1 remove-grid-ml-pl uk-margin-top">
            <div class="uk-width-1-1 author text-right"><b>Vous</b></div>
            <textarea class="uk-width-1-1 card uk-margin-remove-top uk-margin-left uk-margin-right textarea"
            placeholder="Rédiger une réponse"></textarea>
        </div>
        <div class="uk-width-1-1">
            <button class="button uk-float-right uk-margin-right">Envoyer</button>
        </div>
    </div>
</div>